export default __webpack_public_path__ + "static/media/trg.9f214e49.svg";